<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { tabs } from '../hooks/list'
import { useGetRouteQuery } from '~/shared/function'

const type = useGetRouteQuery('type', '0')
const sub = useGetRouteQuery('sub', '0')
</script>

<template>
  <div class="flex items-center border-b-3 border-slate-2 ">
    <n-popover v-for="v, i in tabs" :key="i" trigger="hover" placement="bottom-start" :show-arrow="false">
      <template #trigger>
        <NuxtLink :to="APP_ROUTER.complaintList({ type: i })" class="mr-xl px-2 pb-2 border-b-5 border-transparent -mb-0.6125" :class="{ active: Number(type) === i }">
          {{ v.name }}
        </NuxtLink>
      </template>

      <div class="flex flex-wrap py-2 rounded-md">
        <NuxtLink
          v-for="item, idx in v.sub" :key="idx"
          :to="APP_ROUTER.complaintList({ type: i, sub: idx })"
          class="border-1 border-slate-2 rounded px-sm py-1.5 mx-xs"
          :class="{ 'sub-active': Number(type) === i && Number(sub) === idx }"
        >
          {{ item.name }}
        </NuxtLink>
      </div>
    </n-popover>
  </div>
</template>

<style lang='scss' scoped>
.active {
  --uno: text-blue-5 font-bold border-blue-5;
}
.sub-active {
  --uno: bg-blue-5 text-white;
}
</style>
